import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Work from "@/pages/Work";
import ProjectDetail from "@/pages/ProjectDetail";
import Contact from "@/pages/Contact";
import Methodology from "@/pages/Methodology";
import Awards from "@/pages/Awards";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import AdminBlog from "@/pages/AdminBlog";
import AdminPortfolio from "@/pages/AdminPortfolio";
import AdminNewsletter from "@/pages/AdminNewsletter";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import NotFound from "@/pages/NotFound";
import StudioProfilePdf from "@/pages/StudioProfilePdf";
import SeoManager from "@/components/SeoManager";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            {/* Hidden print-only routes WITHOUT Layout (no navbar/footer) */}
            <Route path="/studio-profile-pdf" element={<StudioProfilePdf />} />
            <Route path="/studio-profile-en" element={<StudioProfilePdf forceLang="en" />} />
            <Route path="/studio-profile-ar" element={<StudioProfilePdf forceLang="ar" />} />
            {/* Admin panel — WITHOUT Layout (own header/logout) */}
            <Route path="/admin/blog" element={<AdminBlog />} />
            <Route path="/admin/portfolio" element={<AdminPortfolio />} />
            <Route path="/admin/newsletter" element={<AdminNewsletter />} />

            {/* All other pages wrapped in Layout */}
            <Route
              path="*"
              element={
                <Layout>
                  <SeoManager />
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/services" element={<Services />} />
                    <Route path="/work" element={<Work />} />
                    <Route path="/methodology" element={<Methodology />} />
                    <Route path="/awards" element={<Awards />} />
                    <Route path="/blog" element={<Blog />} />
                    <Route path="/blog/:slug" element={<BlogPost />} />
                    <Route path="/work/:slug" element={<ProjectDetail />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/privacy" element={<Privacy />} />
                    <Route path="/terms" element={<Terms />} />
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                </Layout>
              }
            />
          </Routes>
          <Toaster
            position="bottom-center"
            theme="dark"
            richColors
            toastOptions={{
              style: {
                background: "#0d0d10",
                border: "1px solid rgba(230,169,91,0.4)",
                color: "#fff",
              },
            }}
          />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
